<template>
    <div class="school_home">

        <div class="school1">
            <h1>院校库</h1>
            <div class="seach_inp_box">
                <input type="text" class="seach_inp" placeholder="伦敦艺术大学" v-model="input1" onfocus="this.placeholder=''"
                    @keydown="enterSubmit">
                <div class="seach_icon_box">
                    <div class="seach_icon" @click="searchSchool()"></div>
                </div>
            </div>
            <div class="s1_rec_box">
                <div>推荐院校：</div>
                <div class="rec_item" @click="handlerec(5, '皇家艺术学院')">皇家艺术学院</div>&nbsp;|&nbsp;
                <div class="rec_item" @click="handlerec(1, '帕森斯设计学院')">帕森斯设计学院</div>&nbsp;|&nbsp;
                <div class="rec_item" @click="handlerec(3, '罗德岛艺术学院')">罗德岛艺术学院</div>
            </div>
        </div>

        <div class="school2" id="school2">
            <div class="s2_cont">
                <div class="s2_top">
                    <div class="s2_top_label">意向国家/地区：</div>
                    <div class="item_box1">

                        <div class="item1" v-for="(item, index) in countryData" :class="{ item1bgc: item.id == countryId }"
                            @click="getcountryId(item.id)">{{ item.cname }}
                        </div>

                        <!-- <div class="item1" v-for="(item, index) in countryData" :class="{ item1bgc: item.id == countryId }"
                            @click="getcountryId(item.id)">
                           
                            <router-link :to="`/school-0-1-'${item}.html`">{{ item.cname }}</router-link> 
                        </div> -->

                        



                    </div>
                </div>
                <div class="s2_top s2_bottom">
                    <div class="s2_top_label">意向专业/方向：</div>
                    <div class="item_box2">
                        <div class="item2" v-for="(item, index) in majorData" :class="{ item2bgc: item.id == majorId }"
                            @click="getmajorId(item.id)">{{ item.cname }}</div>

                    </div>
                </div>
            </div>
        </div>

      

        <div class="school3" id="school3">
            <div class="s3_cont">
                <div class="s3_left">
                    <div class="s3_item" v-for="(item, index) in schoolsData" @click="schoolDetail(item.id, item.cname)">
                        <div class="s3_item_left">
                            <div>
                                <div class="s3_item_imgbox">
                                    <img :src="'https://public.rossoarts.com/static/uploads/' + item.logo" alt="">
                                    <p class="s3_title_cn">{{ item.cname }}</p>
                                    <p class="s3_title_en">{{ item.ename }}</p>
                                </div>
                                <div class="s3_pBox" style="margin-top: 10px;">
                                    <p class="s3_pTtitle">申请难度：</p>
                                    <el-rate v-model="rateValue" disabled text-color="#ff9900" :colors="colors"
                                        score-template="{value}">
                                    </el-rate>
                                </div>
                                <div class="s3_pBox">
                                    <p class="s3_pTtitle">学费：</p>
                                    <div>{{ item.tuition }}</div>
                                </div>
                                <div class="s3_pBox">
                                    <p class="s3_pTtitle">语言成绩：</p>
                                    <div>雅思: 6.0｜托福:N/A｜SAT:N/A</div>
                                </div>
                                <div class="s3_pBox">
                                    <p class="s3_pTtitle">申请截止：</p>
                                    <div style="height: 30px;white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;">{{ item.off_date }}</div>
                                </div>
                                <div class="s3_pBox">
                                    <p class="s3_p_major">
                                        <span class="s3_pTtitle">专业推荐：</span>{{ item.major_id }}
                                    </p>
                                    <!-- <p></p> -->
                                </div>
                            </div>
                            <div class="itemMore_box">
                                <div class="itemMore">
                                    <img src="../img/院校搜索/Group 152.png" alt="">
                                    <p>了解更多</p>
                                </div>
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })" class="itemMore_add"
                                    @click="jopkefu($event)">

                                    <img src="../img/院校搜索/Group 456.png" alt="">
                                    <p>即刻咨询</p>

                                </a>

                            </div>
                        </div>
                        <div class="s3_item_right">
                            <img :src="'https://public.rossoarts.com/static/uploads/' + item.school_img_small" alt="">
                            <div class="top_div">
                                <p class="en">{{ item.admission_num }}</p>
                                <p class="item_mei">枚</p>
                            </div>
                        </div>
                    </div>
                    <el-pagination layout="prev, pager, next" :total="schoolsTotal" :page-size="10"
                        @current-change="handelPage">
                    </el-pagination>

                </div>

                <div class="s3_right">
                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                        <img src="../img/院校搜索/Group 4543.png" alt="" class="s3_rig_top">
                    </a>


                    <div class="s3_right_bot">
                        <div class="s3_right_bot_title">
                            <p class="cn">热门专业</p>
                            <p class="en">ART MAJORS</p>
                        </div>
                        <div class="s3_right_item_box">
                            <div class="s3_right_item" @click="jopMajorDetail(2)">
                                服装设计 &#x3000;&#x3000;>
                            </div>
                            <div class="s3_right_item" @click="jopMajorDetail(4)">
                                动画设计 &#x3000;&#x3000;>
                            </div>
                            <div class="s3_right_item" @click="jopMajorDetail(1)">
                                平面设计 &#x3000;&#x3000;>
                            </div>
                            <div class="s3_right_item" @click="jopMajorDetail(20)">
                                交互设计 &#x3000;&#x3000;>
                            </div>
                        </div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })" class="itemMore2">

                            <img src="../img/院校搜索/Group 152.png" alt="">
                            <p>了解更多</p>
                        </a>

                    </div>

                </div>
            </div>
        </div>

        <div class="section_inp school4">
            <div class="s_inp_left">
                <img src="../img/shouchahua.png" alt="" class="img_shou animated wow rotateInDownLeft" id="imgShou">
                <img src="../img/院校搜索/Group 243.png" alt="" class="img_text animated wow rollIn" id="imgText">
            </div>
            <div class="s_inp_right">
                <el-form :inline="true" :label-position="labelPosition" label-width="150px" :model="formLabelAlign">
                    <el-form-item label="姓名：">
                        <el-input v-model="formLabelAlign.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>


                    <el-form-item label="意向国家：" class="elitem2">
                        <el-select v-model="formLabelAlign.region2" placeholder="选择意向国家">
                            <el-option label="英国" value="England"></el-option>
                            <el-option label="美国" value="America"></el-option>
                            <el-option label="日本" value="Japan"></el-option>
                            <el-option label="新加坡" value="Singapore"></el-option>
                            <el-option label="韩国" value="Korea"></el-option>
                            <el-option label="欧洲" value="Europe"></el-option>

                            <el-option label="其他" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formLabelAlign.tel" placeholder="请输入电话号码"></el-input>
                    </el-form-item>
                    <el-form-item label="留学预算：">
                        <el-input v-model="formLabelAlign.budget" placeholder="请输入您的预算"></el-input>
                    </el-form-item>
                    <el-form-item class="yuyue_box">
                        <div class="yuyue" @click="onSubmit()"></div>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!-- 最外层div -->
    </div>
</template>

<script>
import axios from "axios";
import "../assets/css/schools.css";
import { WOW } from 'wowjs'
export default {

    data() {
        return {
            input1: "",
            username: "",
            countryData: [],
            majorData: [],
            schoolsData: [],
            schoolsTotal: 0,
            schoolsPage: 1,
            countryId: 0,
            majorId: 0,
            rateValue: 3.5,
            // colors:["#FB6333"],
            colors: ['#99A9BF', '#FB6333', '#FF9900'],
            labelPosition: 'right',
            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                budget: '',
            },
        }
    },
    created() {
        this.getArtsMajor()
        this.getCountry()
        this.getArtsSchools()


    },
    methods: {
        jopMajorDetail(val) {
            // window.open(`https://public.rossoarts.com/majors/${val}.html`,"_blank")
            this.$router.push(`/majors/${val}.html`)
        },
        schoolDetail(val, val2) {
            // window.open(`https://public.rossoarts.com/schools/${val}.html`, "_blank")
            // this.$router.push(`/schools/${val}.html`)
            // this.$router.push(`/schools/${val}.html`)
            // console.log(val,val2);
            this.$router.push({

                path: `/schools/${val}.html?cname=${val2}`,

            })
        },
        jopkefu(e) {
            e.stopPropagation();

        },
        onSubmit() {
            // console.log('submit!',this.formInline);
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            var patt = /^1[3-9][0-9]{9}$/

            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');

            } else {
                // console.log("不是空");

                if (patt.test(this.formLabelAlign.tel)) {

                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "budget": this.formLabelAlign.budget,
                        "intended_country":this.formLabelAlign.region2,
                        "url": window.location.href,
                        "status": status,
                    }).then((data) => {
                        console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });

                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');

                }

            }


        },
        enterSubmit() {
            if (event.keyCode == 13) {
                this.searchSchool()
            }
        },
        searchSchool() {
            // console.log(this.input1, "inpu1");
            if (this.input1) {

            } else {
                this.input1 = "伦敦艺术大学"
            }
            axios.get(`https://public.rossoarts.com/api/v1/searchSchool?wd=${this.input1}`).then((data) => {
                // console.log(data.data);
                this.schoolsData = data.data
                this.schoolsTotal = data.total
            })

            school2.scrollIntoView({
                block: 'start',
                behavior: 'smooth',

            })
        },
        handlerec(val, val2) {

            this.$router.push({

                path: `/schools/${val}.html?cname=${val2}`,

            })

        },

        getCountry() {
            axios.get("https://public.rossoarts.com/api/v1/getCountry").then((data) => {
                // console.log(data.data.data);
                this.countryData = data.data.data
            })
        },
        getArtsMajor() {
            axios.get("https://public.rossoarts.com/api/v1/getArtsMajor").then((data) => {
                // console.log(data.data.data.splice(0,30));
                this.majorData = data.data.data.splice(0, 30)
                // console.log(this.majorData);
            })
        },
        getArtsSchools() {
            var arrROSSO = []
            axios.get(`https://public.rossoarts.com/api/v1/getArtsSchools?c=${this.countryId}&m=${this.majorId}&limit=10&page=${this.schoolsPage}`).then((data) => {
                // console.log(data.data.data.data,data.data.data.total)
                // data.data.data.data.forEach((item,index) => {
                //     arrROSSO.push({
                //         "cname":item.cname
                //     })
                // });
                // console.log(arrROSSO);
                // this.majorData = data.data.data
                this.schoolsTotal = data.data.data.total
                this.schoolsData = data.data.data.data
            })
        },

        getcountryId(val) {
            this.countryId = val
            // console.log(val);
            this.getArtsSchools()
            var item1 = document.getElementsByClassName("item1")
            school2.scrollIntoView({
                block: 'start',
                behavior: 'smooth',

            })
        },
        getmajorId(val) {
            this.majorId = val
            // console.log(val);
            this.getArtsSchools()
            school2.scrollIntoView({
                block: 'start',
                behavior: 'smooth',

            })
        },
        handelPage(val) {
            // console.log(val);
            this.schoolsPage = val
            this.getArtsSchools()
        }

    }
}
</script>